import { Dict } from '@altirllc/shared/utils/types/common';

import { LOAD_EVENT_TRACKING_SCRIPTS } from '@/constants';
import { generateTimestamp } from '@/utils/dateUtils';

import { EActionEvents } from './config';
import { Callback, RequestOptions, trackMixpanelEvent } from './providers/mixpanel';

export const trackEvent = (
  eventName: string,
  properties?: Dict<unknown>,
  optionsOrCallback?: RequestOptions | Callback | undefined,
  callback?: Callback | undefined,
) => {
  if (LOAD_EVENT_TRACKING_SCRIPTS) {
    trackMixpanelEvent(
      eventName,
      {
        timestamp: generateTimestamp(),
        ...properties,
      },
      optionsOrCallback,
      callback,
    );
  }
};

export const trackChangeInPageEvent = (pageTo: string, properties?: Dict<unknown>) => {
  trackEvent(EActionEvents.changeInPage, {
    pageFrom: window.location.pathname,
    pageTo,
    ...properties,
  });
};
